/* -----------------------------------------------------------------------------
 * Wizard utils functions
 *
 * @description - Some application wizard utils functions
 * -----------------------------------------------------------------------------
 */

/**
 * Parse steps
 * @description Returns sorted application routes, which marked as step
 * @param {Array} routes - Array of routes objects
 * @returns {Array}
 */
function parseSteps (routes) {
  const s = routes.filter(r => r.meta.step)
  return [...Array(s.length)].map((_, idx) => {
    const r = s.find(r => r.meta.step.idx === idx)
    return { name: r.name, ...r.meta.step }
  })
}

export { parseSteps }
